export const comments_5698799 = {"data":{"data":[],"links":{}}}